


























import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";

export default defineComponent({
  name: "ProgressStepsCard",
  components: { BaseIcon },
  props: {
    title: { type: String, default: "" },
    collapsible: { type: Boolean, default: false },
    collapsed: { type: Boolean, default: false },
    goal: { type: Number, required: true },
    current: { type: Number, required: true },
  },
  setup(props, { emit }) {
    const internalCollapsed = ref(props.collapsed);
    const isCollapsed = computed(() => (props.collapsible ? internalCollapsed.value : false));
    const reached = computed(() => props.current === props.goal);

    const onHeaderClick = () => {
      if (!props.collapsible) return;
      internalCollapsed.value = !internalCollapsed.value;
      emit("update:collapsed", internalCollapsed.value);
    };

    watch(
      () => props.collapsed,
      newVal => {
        internalCollapsed.value = newVal;
      }
    );

    return {
      isCollapsed,
      reached,
      onHeaderClick,
    };
  },
});
